import React from 'react';
import PropTypes from 'prop-types';
import CardBase from './CardBase';

const Quiniary = ({
  tag,
  children,
  loading,
  loadingHeight,
  flat,
  noContentSpace,
  header,
  headerRight,
  boxShadow,
}) => {
  return (
    <CardBase
      tag={tag}
      backgroundColor="green"
      borderColor="green"
      loading={loading}
      loadingHeight={loadingHeight}
      flat={flat}
      noContentSpace={noContentSpace}
      header={header}
      headerRight={headerRight}
      boxShadow={boxShadow}
    >
      {children}
    </CardBase>
  );
};

Quiniary.propTypes = {
  tag: PropTypes.string,
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool,
  loadingHeight: PropTypes.number,
  flat: PropTypes.string,
  noContentSpace: PropTypes.bool,
  header: PropTypes.node,
  headerRight: PropTypes.node,
  boxShadow: PropTypes.string,
};

export default Quiniary;
